import { Validator, validate } from 'jsonschema';

const configValidator = new Validator();

const serviceSchema = {
    id        : '/serviceSchema',
    type      : 'object',
    properties: {
        noWait: {
            type: 'boolean'
        },
        applicationName: {
            type: 'string',
            enum: ['desktop', 'mobile', 'cybersport']
        },
        serviceName: {
            type: 'string',
            enum: ['site', 'booker']
        },
        duplexMethods: {
            type : 'array',
            items: { type: 'string' }
        },
        host: {
            type      : 'object',
            properties: {
                server: {
                    anyOf: [
                        { type: 'string' },
                        { type: 'null' }
                    ]
                },
                client: {
                    anyOf: [
                        { type: 'string' },
                        { type: 'null' }
                    ]
                }
            },
            required: [
                'server',
                'client'
            ]
        },
        timeout: {
            type      : 'object',
            properties: {
                server: {
                    anyOf: [
                        { type: 'integer' },
                        { type: 'null' }
                    ]
                },
                client: {
                    anyOf: [
                        { type: 'integer' },
                        { type: 'null' }
                    ]
                }
            },
            required: ['server', 'client']
        },
        protocol: {
            type      : 'object',
            properties: {
                socketIOQueueLength: {
                    type: 'integer'
                },
                websocket: {
                    type: 'boolean'
                },
                polling: {
                    type: 'boolean'
                },
                rest: {
                    type: 'boolean'
                },
                restURLPathPrefix: {
                    type: 'string'
                }
            },
            required: [
                'socketIOQueueLength',
                'websocket',
                'polling',
                'rest',
                'restURLPathPrefix'
            ]
        }
    },
    required: [
        'duplexMethods',
        'timeout',
        'host',
        'protocol',
        'serviceName',
        'applicationName'
    ]
};

const configSchema = {
    type      : 'object',
    properties: {
        booker: { $ref: '/serviceSchema' },
        site  : { $ref: '/serviceSchema' }
    }
};

configValidator.addSchema(serviceSchema, '/serviceSchema');

const responseSchema = {
    type      : 'object',
    properties: {
        httpCode: {
            type: 'integer'
        },
        meta: {
            type      : 'object',
            properties: {
                uuid: {
                    type: 'string'
                },
                token: {
                    type: 'string'
                }
            }
        }
    },
    required: [
        'result',
        'httpCode',
        'id'
    ]
};

const validateResponse = (response) => validate(response, responseSchema);
const validateConfig = (config) => configValidator.validate(config, configSchema);

export {
    responseSchema,
    configSchema,
    validateConfig,
    validateResponse
}



// WEBPACK FOOTER //
// ./node_modules/core-ui__transport/schemas.js